import { UserProfileDataT } from "src/types/userTypes";
import { authorized } from "./api";

export const getUserProfile = async () => {
  const resp = await authorized.get("/users/profile");
  return resp.data;
};
export const putUserProfile = async (body: FormData | UserProfileDataT) => {
  const resp = await authorized.put("/users", body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return resp.data;
};

export const userLogout = async () => {
  const resp = await authorized.post("/users/logout");
  return resp.data;
};

export const pictureUploadData = {
  url: `${import.meta.env.VITE_API_BASE_URL}/users/upload`,
  get headers() {
    const accessToken = localStorage.getItem("access-token");
    return {
      Authorization: `Bearer ${accessToken}`,
    };
  },
};
